import { Typography } from "@mui/material";
import styled, { DefaultTheme } from "styled-components/macro";

export const LandingGeneralContainer = styled.div`
  margin-top: 30px;
  padding: 25px;
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.boxShadow};

  h5 {
    padding-bottom: 20px;
  }
`;

export const FileUploaderWrapper = styled.div``;

export const FileUploaderDropzoneWrapper = styled.div`
  justify-content: center;
  display: flex;

  .dzu-dropzoneActive {
    opacity: 0.7;
  }

  .dzu-inputLabelWithFiles {
    color: ${({ theme }) => theme.redMedium};
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.redMedium};
    border-radius: 3rem;
    width: 90px;
    font-size: 14px !important;
    margin: 10px 10px !important;
  }
`;

export const FileUploaderDropzone = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  grid-row-gap: 7px;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.secondaryBackgroundColor};
  padding: 36px 0 36px 0;
`;

export const FileUploaderDropzoneLimit = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.greyMedium};
  text-align: center;
  font-family: light;
  font-weight: 400;
  margin-bottom: 10px;
`;

export const FileUploaderIcon = styled.div`
  display: flex;
  justify-content: center;

  svg {
    padding-top: 10px;
    height: 40px;
    width: 40px;
    color: ${({ theme }) => theme.redMedium};
  }
`;

export const FileUploaderTitle = styled(Typography)`
  margin-top: -25px;
  color: ${({ theme }) => theme.redMedium};
  font-family: bold !important;
  font-weight: 700 !important;
  font-size: 18px;
  line-height: 24px;
`;

export const FileUploaderBrowse = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.redMedium};
  border: 1px solid ${({ theme }) => theme.white};
  border-radius: 3rem;
  padding: 5px 0;
  width: 140px;
  font-family: light;
  font-size: 14px !important;
  margin: auto !important;
  text-transform: uppercase;
  font-weight: bold !important;

  :hover {
    padding: 5px 1px;
    opacity: 0.9;
  }
`;

const getUploadBorder = (validUpload?: boolean) => {
  if (validUpload === undefined) {
    return "2px dashed orange";
  }
  if (validUpload) {
    return "2px dashed green";
  }
  return "2px dashed red";
};

const getPreviewBackground = (theme: DefaultTheme, validUpload?: boolean) => {
  if (validUpload === undefined) {
    return theme.yellowPastel;
  }
  if (validUpload) {
    return theme.greenPastel;
  }
  return theme.redPastel;
};

export const FileUploaderPreview = styled.div<{
  validUpload?: boolean;
  previewUrl?: string;
}>`
  display: grid;
  grid-template-columns: auto auto;
  border-radius: 6px;
  background-color: ${({ validUpload, theme }) =>
    getPreviewBackground(theme, validUpload)};
  height: auto;
  min-width: 275px;
  width: 90%;
  padding: 10px 10px;
  border: ${({ validUpload }) => getUploadBorder(validUpload)};
  margin: 8px 0px 0px 0px;

  img {
    width: 80px;
    height: auto;
  }
`;

export const FileUploaderPreviewButton = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 16px;
  gap: 10px;
  color: ${({ theme }) => theme.redMedium};
  width: 82px;
  right: 16px;
  top: 25%;
  bottom: 25%;
  border: 1px solid ${({ theme }) => theme.redMedium};
  border-radius: 30px;
  cursor: pointer;
  font-weight: 700;

  :hover {
    padding: 5px 17px;
  }
`;

export const FileUploaderSubmitButton = styled.div<{ disabled: boolean }>`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 28px;
  margin-top: 10px;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.redMedium};
  border: 1px solid ${({ theme }) => theme.white};
  border-radius: 30px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-weight: 700;
  opacity: ${({ disabled }) => (disabled ? ".7" : undefined)};

  :hover {
    padding: ${({ disabled }) => (disabled ? "12px 28px" : "13px 29px")};
  }
`;

export const FileUploaderPreviewTitle = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-self: flex-start;
  align-items: center;
  grid-column-gap: 20px;
`;

export const FileUploaderUploadFile = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-self: flex-start;
  align-items: center;
`;

export const FileUploaderPreviewDelete = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-self: flex-end;
  align-items: center;
  grid-column-gap: 20px;
`;

export const FileUploaderPreviewError = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.redMedium};
`;

export const FileUploadSubmitWrapper = styled.div`
  display: flex;
  justify-content: center;

  ${FileUploaderPreviewButton} {
    margin-top: 10px;
    margin-right: 10px;
    align-self: center;
  }
`;

export const FileUploadMessage = styled.div`
  display: flex;
  margin: 10px 0px;
`;
